/* eslint-disable */

import { useEffect, useMemo, useState } from "react";
import ReactTable from 'react-table';
import { VerticalDotsSvg } from "../../assets/svgs";
import { BackButton, BadgeComponent, Breadcrumbs, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { getAllFileImportLogs, resetSelected } from "../../redux/slices/card-status-file-import-logs-slice";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { useLocation } from "react-router";
import { Menus } from "../../constants/menus-constant";
import ViewCardStatusFileImportLogsModal from "../../components/view-card-status-file-import-logs-modal";
import moment from "moment";

const CardStatusFileImportLogs = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.loginUserReducer);

    const { loading, fileImportLogsData, pagination } = useSelector((state) => state.cardStatusFileImportLogsReducer);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };

    const initialOrderBy = {
        sortColumn: "updatedAt",
        isAsce: false,
    };

    const initialSearch = {
        // id: '',
        // name: '',
        // status: '',
        // totalRecords: '',
        // validRecords: '',
        // invalidRecords: '',
        // appliedRecords: '',
        // receiveAt: ''
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const defaultParams = {
        pagination: states.pagination,
        orderBy: states.orderBy,
        search: states.search
    };

    const getAllCardStatusData = async (updatedParams) => {
        if (user && updatedParams) {
            try {
                await Promise.all([
                    // dispatch(getApiConfigValues(user)),
                    dispatch(getAllFileImportLogs({ user, ...updatedParams })),
                ]);
            } catch (error) {
                console.error("One or more API calls failed", error);
            }
        };
    };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllCardStatusData(params);
    };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    const handleModalOpen = (id) => {
        setStates((old) => ({ ...old, isModalOpen: true }));
        // if (id) {
        //     dispatch(getCardStatusByID({ user, id })).then((action) => {
        //         if (action?.payload?.status === 201 || action?.payload?.status === 200) {
        //             setStates((old) => ({ ...old, isModalOpen: true }));
        //         }
        //     });
        // }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null, isUpdate: false, isView: false }));
        dispatch(resetSelected());
    };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        
        const cleanedSearch = Object.keys(searchToUse).reduce((acc, key) => {
            const value = searchToUse[key];
            if (value !== '' && value !== null && value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
        
        const params = {
            ...defaultParams,
            search: cleanedSearch,
            pagination: initialPagination,
        };
        getAllCardStatusData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search };
            
            if (value === '' || value === null || value === undefined) {
                delete updatedSearch[key];
            } else {
                updatedSearch[key] = value;
            }
            
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    const actions = (id) => {
        const actionsList = [
            { label: 'View more', action: () => handleModalOpen(id) },
        ];

        return actionsList;
    };

    useEffect(() => {
        getAllCardStatusData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (fileImportLogsData && Array.isArray(fileImportLogsData)) {
            setStates((old) => ({ ...old, data: fileImportLogsData, pagination: pagination }));
        }
    }, [fileImportLogsData, pagination]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const columns = useMemo(() => [
        {
            accessor: 'id',
            Header: 'File ID',
            minWidth: 110,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row.original?.id,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="id"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('id', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('id', value, true);
                        }
                    }}
                    placeholder="Search by ID"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'name',
            Header: 'File Name',
            minWidth: 200,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="name"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('name', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) handleTableFilterChange('name', e.target.value, true); }}
                    placeholder="Search by File Name"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        // {
        //     accessor: 'type',
        //     Header: 'Type',
        //     minWidth: 200,
        //     Cell: (row) => {
        //         const status = row?.original?.type?.toLowerCase();
        //         let type = 'default';
        //         let outline = false;
        //         if (status === 'active') type = 'success';
        //         else if (status === 'warm') type = 'warning';
        //         else if (status === 'hot') type = 'error';
        //         else if (status === 'fresh') type = 'default';
        //         return <BadgeComponent label={status} type={type} outline={outline} />;
        //     },
        //     Filter: ({ filter, onChange }) => (
        //         <input
        //             type="text"
        //             name="type"
        //             value={filter ? filter.value : ''}
        //             onChange={e => { onChange(e.target.value); handleTableFilterChange('type', e.target.value); }}
        //             onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('type', e.target.value, true); }}
        //             placeholder="Search by Type"
        //             style={{ width: '100%' }}
        //         />
        //     ),
        //     sortable: false,
        // },
        {
            accessor: 'receiveAt',
            Header: 'Received At',
            minWidth: 160,
            style: {
                textAlign: 'center'
            },
            Cell: row => row?.original?.receiveAt ? moment(row?.original?.receiveAt).format('lll') : '',
            Filter: ({ filter, onChange }) => (
                <input
                    type="date"
                    name="receiveAt"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('receiveAt', value, true);
                    }}
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'totalRecords',
            Header: 'Total',
            minWidth: 140,
            sortable: false,
            Cell: row => (<div style={{ fontWeight: 'bold' }}>{row?.original?.totalRecords ?? 0}</div>),
            Filter: ({ filter, onChange }) => (
                <input
                    type="number"
                    name="totalRecords"
                    value={filter ? filter.value : ''}
                    onChange={e => {
                        const value = e.target.value ? Number(e.target.value) : '';
                        onChange(value);
                        handleTableFilterChange('totalRecords', value);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            const value = e.target.value ? Number(e.target.value) : '';
                            handleTableFilterChange('totalRecords', value, true);
                        }
                    }}
                    placeholder="Search by Total"
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            accessor: 'validRecords',
            Header: 'Valid',
            minWidth: 140,
            color: 'green',
            sortable: false,
            Cell: row => (<div style={{ color: '#397D4E', fontWeight: 'bold' }}>{row?.original?.validRecords ?? 0}</div>),
            Filter: ({ filter, onChange }) => (
                <input
                    type="number"
                    name="validRecords"
                    value={filter ? filter.value : ''}
                    onChange={e => {
                        const value = e.target.value ? Number(e.target.value) : '';
                        onChange(value);
                        handleTableFilterChange('validRecords', value);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            const value = e.target.value ? Number(e.target.value) : '';
                            handleTableFilterChange('validRecords', value, true);
                        }
                    }}
                    placeholder="Search by Valid"
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            accessor: 'invalidRecords',
            Header: 'Invalid',
            minWidth: 150,
            sortable: false,
            Cell: row => (<div style={{ color: '#CF4C4A', fontWeight: 'bold' }}>{row?.original?.invalidRecords ?? 0}</div>),
            Filter: ({ filter, onChange }) => (
                <input
                    type="number"
                    name="invalidRecords"
                    value={filter ? filter.value : ''}
                    onChange={e => {
                        const value = e.target.value ? Number(e.target.value) : '';
                        onChange(value);
                        handleTableFilterChange('invalidRecords', value);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            const value = e.target.value ? Number(e.target.value) : '';
                            handleTableFilterChange('invalidRecords', value, true);
                        }
                    }}
                    placeholder="Search by Invalid"
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            accessor: 'appliedRecords',
            Header: 'Applied',
            minWidth: 160,
            Cell: row => (<div style={{ color: '#3989d8', fontWeight: 'bold' }}>{row?.original?.appliedRecords ?? 0}</div>),
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="number"
                    name="appliedRecords"
                    value={filter ? filter.value : ''}
                    onChange={e => {
                        const value = e.target.value ? Number(e.target.value) : '';
                        onChange(value);
                        handleTableFilterChange('appliedRecords', value);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            const value = e.target.value ? Number(e.target.value) : '';
                            handleTableFilterChange('appliedRecords', value, true);
                        }
                    }}
                    placeholder="Search by Applied"
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            accessor: 'status',
            Header: 'Status',
            minWidth: 140,
            Cell: (row) => {
                const status = row?.original?.status?.toLowerCase();
                let type = 'default';
                let outline = false;
                return <BadgeComponent label={status} type={type} outline={outline} />;
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="status"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('status', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('status', e.target.value, true); }}
                    placeholder="Search by Status"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent
                            outline={!(states.isDropdownOpen && states.selected === row?.original)}
                            size='small'
                            icon={VerticalDotsSvg}
                            onClick={() => handleSelectRow(row?.original)}
                        />
                        <DropDownComponent
                            isOpen={states.isDropdownOpen && states.selected === row?.original}
                            close={handleCloseDropdown}
                            actions={actions(row?.original?.cardId)} // <-- use cardId here
                        />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>File Import Logs</h1>
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>
            </AuthPageHead>

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                // <Fragment>
                //     <TableComponent rows={states.data} columns={columns} icon={HistorySvg} />
                //     <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} />
                // </Fragment>
                <>
                    <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <ViewCardStatusFileImportLogsModal
                    data={states.selected}
                    close={handleModalClose}
                    label="File Imports Details"
                    slide
                />
            }
        </AuthPageContainer>
    );
};

export default CardStatusFileImportLogs;